import React, { useState, useEffect, useContext } from 'react'
import { types } from '../types.js'
import { Helmet } from 'react-helmet'

import { GlobalContext, isProduct, isExperienceManager } from '../../utility'

import { ANALYTICS_PAGE_VIEW, sendAnalyticsPageview } from '../../analytics'

import {
  isInstitutional,
  isInvestor,
} from '../../../global/authentication/authentication-manager'

export function Metadata({ page, component }) {
  const [isSent, setIsSent] = useState()

  const { document, breadcrumbs, setDocument } = useContext(GlobalContext)

  const _parameters = component.getParameters()

  useEffect(() => {
    setDocument({})
  }, [page])

  useEffect(() => {
    setTimeout(() => {
      window.prerenderReady = true
    }, 5000)
  }, [])

  useEffect(() => {
    const pageHasMetamenu = findComponentOnPage('Metamenu2')
    const pageHasSocial = findComponentOnPage('Social2')
    const siteName = isInstitutional()
      ? 'ctiusinstitutional'
      : isInvestor()
        ? 'ctiusinvestor'
        : 'ctius'

    if (
      isSent !== window.location.pathname &&
      (!pageHasMetamenu ||
        (breadcrumbs && breadcrumbs.href === window.location.href)) &&
      (!pageHasSocial || (document && document.href === window.location.href))
    ) {
      window.digitalData = {
        ...window.digitalData,
        page: {
          ...window.digitalData?.page,
          pageInfo: {
            ...window.digitalData?.page?.pageInfo,
            pageName: getPageTitle(),
            destinationURL: window.location.href,
            breadCrumbs: ['Home'].concat(
              breadcrumbs?.payload?.map((b) => b.name) || []
            ),
            language: 'en-us',
            geoRegion: 'US',
            contentTags: document?.payload?.keys || [],
            siteName: siteName,
          },
          attributes: {
            siteName: siteName,
            dataLayerType: 'dynamic',
          },
        },
        version: '1.0',
      }

      if (document?.payload?.publicationDate) {
        window.digitalData.page.pageInfo.publicationDate = new Date(
          document?.payload?.publicationDate
        ).toLocaleDateString('en-us', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      }

      // Only send `productInfo` if within Strategy pages
      if (isProduct()) {
        window.digitalData.product = {
          productInfo: {
            assetClass: document?.payload?.subtitle || '',
            productName: document?.payload?.title || '',
          },
        }
      }
      sendAnalyticsPageview(ANALYTICS_PAGE_VIEW)
      setIsSent(window.location.pathname)
    }
  }, [page, document, breadcrumbs])

  function findComponentOnPage(component) {
    return Object.keys(page.model.page).find(
      (entry) => page.model.page[entry].name === component
    )
  }

  const replaceTokens = (text, title) => {
    return text
      .replace('{title}', title)
      .replace('{subtitle}', document?.payload?.subtitle)
      .replace(
        '{html}',
        document?.payload?.html?.replace('<p>', '').replace('</p>', '') || ''
      )
  }

  const getPageTitle = () => {
    return (
      document?.payload?.title ||
      page.getTitle() ||
      component?.getParameters()?.title
    )
  }

  const getTitle = () => {
    let title = getPageTitle()

    if (_parameters.title) {
      title = replaceTokens(_parameters.title?.split('||')[0]?.trim(), title)
    }

    return !title || title?.indexOf('Columbia Threadneedle Investments') > -1
      ? title
      : title + ' | Columbia Threadneedle Investments US'
  }

  const getDescription = () => {
    let description = getPageTitle()

    if (_parameters.description) {
      description = replaceTokens(
        _parameters.description?.split('||')[0]?.trim(),
        description
      )
    }

    return description
  }

  const getOmniTitle = () => {
    let title = document?.payload?.title || page.getTitle()

    if (_parameters.omniTitle) {
      title = replaceTokens(_parameters.omniTitle, title)
    }

    return title
  }

  const getOmniDescription = () => {
    let description = getDescription()

    if (_parameters.omniDescription) {
      description = replaceTokens(_parameters.omniDescription, description)
    }

    return description
  }

  const getOgTitle = () => {
    let title = document?.payload?.title || page.getTitle()

    if (_parameters.ogTitle) {
      title = replaceTokens(_parameters.ogTitle, title)
    }

    return title
  }

  const getOgDescription = () => {
    let description = getDescription()

    if (_parameters.ogDescription) {
      description = replaceTokens(_parameters.ogDescription, description)
    }

    return description
  }

  const _title = getTitle()
  const _desc = getDescription()
  const _omniTitle = getOmniTitle()
  const _omniDescription = getOmniDescription()
  const _ogTitle = getOgTitle()
  const _ogDescription = getOgDescription()

  return (
    <>
      {isExperienceManager(page) && (
        <div className="u-sizeConstrained u-textBold u-paddingVert5gu u-marginTop10gu">
          Metadata
        </div>
      )}
      <Helmet defer={false}>
        {_title ? <title>{_title}</title> : ''}
        {_desc ? <meta name="description" content={_desc} /> : ''}
        {_omniTitle ? <meta name="omni_title" content={_omniTitle} /> : ''}
        {_omniDescription ? (
          <meta name="omni_description" content={_omniDescription} />
        ) : (
          ''
        )}
        {_ogTitle ? <meta property="og:title" content={_ogTitle} /> : ''}
        {_ogDescription ? (
          <meta property="og:description" content={_ogDescription} />
        ) : (
          ''
        )}
        {document?.payload?.imageUrl && (
          <meta
            property="og:image"
            content={window.location.origin + document.payload.imageUrl}
          />
        )}
      </Helmet>
    </>
  )
}

Metadata.propTypes = {
  ...types,
}
